export const googleChartsVersion = '47';

// noinspection JSUnusedGlobalSymbols
export default function(){
    // Load the Visualization API.
    google.charts.load(googleChartsVersion, {packages: ['corechart'], callback: drawCharts});
}

function drawCharts() {
    $('.sl-chart').each(function () {
        drawChart($(this).data('chart-opt'));
    });
}

function drawChart(chart: any) {

    // Don't use arrayToDataTable(), it has a nasty bug with null values in the first row:
    //https://groups.google.com/forum/?fromgroups=#!topic/google-visualization-api/2Jafk8PyjV4
    const data = chart['data'];
    const dataTable = new google.visualization.DataTable();
    const columns = data.shift();
    dataTable.addColumn('string', 'Labels');
    for (let iCol = 1; iCol < columns.length; iCol++) {
        dataTable.addColumn('number', columns[iCol]);
    }
    dataTable.addRows(data);

    // Format data for tooltip.
    const formatter = new google.visualization.NumberFormat({
        pattern: chart['options']['dataPattern']
    });
    for (let iCol = 1; iCol < dataTable.getNumberOfColumns(); iCol++) {
        formatter.format(dataTable, iCol);
    }

    // Instantiate and draw our chart, passing in some options.
    const chartElement = document.getElementById(chart['id']);
    // @ts-ignore
    const googleChart = new google.visualization[chart['type']](chartElement);
    googleChart.draw(dataTable, chart['options']);

    // redraw charts at resize to make them responsive
    // use timeout to prevent redrawing too many times
    let chartTimeout: number;
    $(window).on('resize', function () {
        clearTimeout(chartTimeout);
        chartTimeout = <number><any>setTimeout(function () {
            googleChart.draw(dataTable, chart['options']);
        }, 50);
    });

}
